import { Alert } from "./alert";

interface IAlertProps {
  message: string | null;
  className?: string;
}

export function AuthErrorMessage({ message, className }: IAlertProps) {
  console.log("message :", typeof message);
  if (!message || message === "SessionRequired") {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <div
      className={`${
        className || ""
      } flex flex-row justify-center items-center gap-2 my-4 text-error`}
    >
      {message ? <Alert type="error" message={message} /> : null}
    </div>
  );
}
